import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { ClientContactImpl } from "../model/impl/ClientContactImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class ClientContactImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: ClientContactImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.id != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(1),
        false,
        encodable.id,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.clientCd != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(2),
        false,
        encodable.clientCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.contactNameTxt != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(3),
        false,
        encodable.contactNameTxt,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.deskTxt != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(4),
        false,
        encodable.deskTxt,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.mobileTxt != null) {
      this.baseEncoder.writeStartFid(5, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(5),
        false,
        encodable.mobileTxt,
        streamout,
      );
      this.baseEncoder.writeEndFid(5, streamout);
    }
    /*Object encoding*/
    if (encodable.smsTxt != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(6),
        false,
        encodable.smsTxt,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.emailTxt != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(7),
        false,
        encodable.emailTxt,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.notifyEntry != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(8),
        false,
        encodable.notifyEntry,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.notifyFill != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(9),
        false,
        encodable.notifyFill,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.notifyExpiry != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(10),
        false,
        encodable.notifyExpiry,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.isDefaultFg != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(11),
        false,
        encodable.isDefaultFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.notifyModify != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(12),
        false,
        encodable.notifyModify,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.notifyCancel != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(13),
        false,
        encodable.notifyCancel,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        ClientContactImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,ClientContactImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.Long"],
    [2, "java.lang.String"],
    [3, "java.lang.String"],
    [4, "java.lang.String"],
    [5, "java.lang.String"],
    [6, "java.lang.String"],
    [7, "java.lang.String"],
    [8, "com.bcdfx.model.NotificationMethod"],
    [9, "com.bcdfx.model.NotificationMethod"],
    [10, "com.bcdfx.model.NotificationMethod"],
    [11, "java.lang.Boolean"],
    [12, "com.bcdfx.model.NotificationMethod"],
    [13, "com.bcdfx.model.NotificationMethod"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: ClientContactImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.id = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.clientCd = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.contactNameTxt = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.deskTxt = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          encodable.mobileTxt = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.smsTxt = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.emailTxt = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.NotificationMethod = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.notifyEntry = <CubiqTS.NotificationMethod>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: CubiqTS.NotificationMethod = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.notifyFill = <CubiqTS.NotificationMethod>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: CubiqTS.NotificationMethod = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.notifyExpiry = <CubiqTS.NotificationMethod>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.isDefaultFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: CubiqTS.NotificationMethod = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.notifyModify = <CubiqTS.NotificationMethod>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: CubiqTS.NotificationMethod = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.notifyCancel = <CubiqTS.NotificationMethod>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            ClientContactImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,ClientContactImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return ClientContactImplEncoder.fidTypeMap.has(fid);
  }
}
